import { useState, useEffect, } from "react";
import { useToken } from "../../../utilities/hooks";
import { useDispatch, useSelector } from 'react-redux';
// import { downloadDailyETADeliveryRateReport, getDailyETADeliveryRate } from '../../../actions/edrrActions';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box, Grid, Button, TextField,
    CircularProgress, Checkbox,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getUserPreference } from "../../../utilities/common";
import { withStyles } from "@material-ui/styles";
import { showAlertSnackbar } from "../../../reducers/uiSlice";

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 160,
        marginLeft: 20
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    containerStyle: {
        display: "flex",
        alignItems: "center",
        marginTop: 10
    },
    spanStyle: {
        display: "inline-block",
        padding: '0 20px',
        paddingTop: '5px'
    },
    buttonStyle: {
        padding: '10px 10px',
        marginLeft: 20
    },
    checkboxesStyle: {
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center',
        marginTop: 20,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    },
    checkboxStyleChecked: {
        display: 'flex',
        alignItems: 'center',
        border: 'solid 1px #ff9800',
        borderRadius: 5,
        padding: '1px 10px',
        marginTop: 10,
        marginRight: 10
    },
    checkboxStyle: {
        display: 'flex',
        alignItems: 'center',
        border: 'solid 1px #c8c8c8',
        borderRadius: 5,
        padding: '1px 10px',
        marginTop: 10,
        marginRight: 10
    },
    checkboxTextStyleChecked: {
        color: '#ff9800'
    },
    checkboxTextStyle: {
        color: '#c8c8c8'
    }
}));

const moment = require('moment');

function ReportSearch() {
    const { t } = useTranslation('etaDeliveryRateReport');
    const classes = useStyles();
    const dispatch = useDispatch();
    const branches = useSelector(state => state.common.branches);
    const tokenContents = useToken();

    const userPref = getUserPreference();

    const authorizedWarehouses = tokenContents.warehouse;

    const [selectedWarehouse, setSelectedWarehouse] = useState([]);

    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);
    const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [partnerId, setPartnerId] = useState(75);

    const handleWarehouseListClick = (id) => {
        if (selectedWarehouse.indexOf(id) === -1) {
            setSelectedWarehouse([...selectedWarehouse, id]);
        } else {
            setSelectedWarehouse(
                selectedWarehouse.filter(
                    (warehouse) => (warehouse !== id)
                )
            );
        }
    };

    const handleAllWarehouseClick = async () => {
        await setIsCheckedAll(!isCheckedAll);

        isCheckedAll ?
            setSelectedWarehouse([]) :
            setSelectedWarehouse(authorizedWarehouses);
    };

    const handleSearch = (dateFrom, dateTo) => {
        const moment = require('moment');
        const dateFromNum = moment(dateFrom).startOf('day').valueOf();
        const dateToNum = Math.floor(moment(dateTo).endOf('day').valueOf());
        const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
        const diffDays = Math.round(Math.abs((dateFromNum - dateToNum) / oneDay));
        if (diffDays > 30) {
            dispatch(showAlertSnackbar({ message: t('no_exceed_days'), type: "warning" }))
        } else {
            setLoading(true);
            setDisable(true);
            const dateFromStr = dateFrom.replaceAll('-', '');
            const dateToStr = dateTo.replaceAll('-', '');

            const axios = require('axios');
            const baseURL = process.env.REACT_APP_MAP_SERVER_URL;
            const getXLS = () => {
                return axios.get(`${baseURL}/business/downloadDailyETADeliveryRateReport?start_time=${dateFromStr}&end_time=${dateToStr}&warehouses=${selectedWarehouse}&partner_id=${partnerId}`, {
                    responseType: 'blob',
                })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'DeliveryRateReport.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    })
                    .finally(() => {
                        setLoading(false);
                        setDisable(false);
                    })
            }
            getXLS();
        }
    }

    function handleDateTo(event) {
        const dateToTamp = moment(event.target.value).unix();
        const dateFromTamp = moment(dateFrom).unix();
        if (dateToTamp < dateFromTamp) {
            setDateTo(dateFrom);
            dispatch(showAlertSnackbar({ message: t('no_larger_end'), type: 'error' }));
        } else {
            setDateTo(event.target.value);
        }
    }

    // useEffect(() => { console.log(selectedWarehouse) }, [selectedWarehouse]);

    useEffect(() => {
        if (branches) {
            if (branches.length > 0) {
                handleWarehouseListClick(userPref.userCity);
                setIsCheckedAll(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Box>
            <Grid container className={classes.containerStyle}>
                <TextField
                    size="small"
                    id="searchStartDate"
                    type="date"
                    variant="outlined"
                    value={dateFrom}
                    onChange={(e) => setDateFrom(e.target.value)}
                />
                <span className={classes.spanStyle}>{t('to')}</span>
                <TextField
                    size="small"
                    id="searchStartDate"
                    type="date"
                    variant="outlined"
                    value={dateTo}
                    onChange={handleDateTo}
                />
                <FixedTextField
                    fullWidth
                    select
                    label={t('partner')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={partnerId}
                    onChange={(e) => { setPartnerId(e.target.value) }}
                >
                    {/* For now GV partner id is 75, search sdkluvguw to change to 17 all related */}
                    <option value={75}>
                        GV
                    </option>
                    <option value={24}>
                        CNE
                    </option>
                </FixedTextField>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleSearch(dateFrom, dateTo)}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('download')}
                </Button>
                {
                    loading &&
                    <div className={classes.buttonStyle}>
                        <CircularProgress color='secondary' />
                    </div>
                }
            </Grid>
            <div className={classes.checkboxesStyle}>
                <span
                    className={isCheckedAll ? classes.checkboxStyleChecked : classes.checkboxStyle}
                    style={{ maxWidth: 80 }}
                >
                    <Checkbox
                        color="primary"
                        onClick={() => { handleAllWarehouseClick() }}
                        checked={isCheckedAll}
                        tabIndex={-1}
                    />
                    <span
                        className={isCheckedAll ? classes.checkboxTextStyleChecked : classes.checkboxTextStyle}
                    >
                        {t('check_all')}
                    </span>
                </span>
                {
                    branches &&
                    branches.filter(
                        (branch) => (authorizedWarehouses.includes(branch.id))
                    ).map((branch) => {
                        return (
                            <span
                                className={selectedWarehouse.indexOf(branch.id) !== -1 ? classes.checkboxStyleChecked : classes.checkboxStyle}
                            >
                                <Checkbox
                                    color="primary"
                                    onClick={() => { handleWarehouseListClick(branch.id) }}
                                    checked={selectedWarehouse.indexOf(branch.id) !== -1}
                                    disabled={!authorizedWarehouses.includes(branch.id)}
                                    tabIndex={-1}
                                />
                                <span
                                    className={selectedWarehouse.indexOf(branch.id) !== -1 ? classes.checkboxTextStyleChecked : classes.checkboxTextStyle}
                                >
                                    {branch.name}
                                </span>
                            </span>
                        )
                    })
                }
            </div>
        </Box>
    );
}

export default ReportSearch;